@if (text) {
<div class="clipped-text" [matTooltip]="('shared.showMore' | translate)" matTooltipPosition="above"
    [matMenuTriggerFor]="textDetailsMenu" #menuTrigger="matMenuTrigger" appRowHighlightOnMenuOpen>
    {{ text }}
</div>

<mat-menu #textDetailsMenu="matMenu" xPosition="before" yPosition="above" class="clipped-text-popup">
    @if (title) {
    <h4 class="typo-title-medium font-regular mb-2">
        {{ title }}
    </h4>
    }
    <div class="clipped-text__container" (click)="$event.stopPropagation()">
        <span style="line-height: 1.6;">
            {{ text }}
        </span>
        <icon name="content_copy" class="d-inline-block cursor-pointer margin-start-xs" (click)="copyText()"
            *ngIf="!copied">
        </icon>
        <span class="copied-feedback margin-start-xs" *ngIf="copied">
            {{ 'shared.copied' | translate }}
        </span>
    </div>
    <div class="d-flex justify-content-end mt-2">
        <button id="btn_gotIt" mat-stroked-button color="primary">
            {{ 'buttons.gotIt' | translate }}
        </button>
    </div>
</mat-menu>
}
